// extracted by mini-css-extract-plugin
module.exports = {"root":"Navigation_root__34mPD"};